export default "__VITE_ASSET__D1RGpPm3__"